import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { TechnologyStep } from "../../../lib/types";
import { investTechPoint } from "../../../store/actions/technology";

interface IProps {
  step: TechnologyStep;
  technologyId: number;
  level: number;
  available: boolean;
}

const mapDispatchToProps = (dispatch: any) => ({
  investTechPointDispatch: (technologyId: number) => dispatch(investTechPoint(technologyId)),
});

const connector = connect(null, mapDispatchToProps);

const TechnologyStepInfo = ({
  step,
  technologyId,
  level,
  available,
  investTechPointDispatch
}: IProps & ConnectedProps<typeof connector>) => (
  <>
    <h3 className="title">{step.name}</h3>
    <p className="text-center">
      <strong>Level: {level}/8</strong><br/>
      {step.description}<br/>
      {step.productionBonusMessage}
    </p>
    {available
      ? <a href="#"
           onClick={() => investTechPointDispatch(technologyId)}
           className="btn btn-black"
           tabIndex={0}
      >
        Invest {step.points} points
      </a>
      : <></>}
    {!step.available && level !== step.stepId - 1
      ? <span className="negative">{step.available}</span> : <></>
    }
  </>
)

export default connector(TechnologyStepInfo);
